import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation, type Variables } from '../../../hooks/use-optimistic-mutation';
import type { Discount } from '../types';
import { useDiscountsApi } from './use-discounts-api';
import { QK_DISCOUNTS_LIST } from './use-discounts-list';

export function useDeleteDiscount() {
  const { discountsApi } = useDiscountsApi();
  const queryClient = useQueryClient();

  async function deleteDiscount(id: string) {
    await discountsApi.discount(id).delete();
  }

  return useOptimisticMutation<Discount[], Variables<typeof deleteDiscount>>({
    mutationFn: deleteDiscount,
    queryKey: QK_DISCOUNTS_LIST(),
    queryClient,
    optimisticUpdate: (prev, id) => prev?.filter((discount) => discount.id !== id) ?? [],
  });
}
